<template>
  <div class="article-body-blockquote" :style="style">
    <div class="quote-container">
      <template v-for="(quote, index) in itemQuotes">
        <div :class="[quoteClassName(quote.quoteType), 'quote']" :key="index">
          <div class="quotes">
            <div class="quotes__icon">
              <single-quote-svg></single-quote-svg>
            </div>
            <div class="quotes__icon">
              <single-quote-svg></single-quote-svg>
            </div>
          </div>
          {{ quote.value }}
        </div>

      </template>
    </div>

    <div class="share-buttons-container">
      <amp-share-pane :node="node"
                  :mode="'blockquote'"
                  :quote="shareTitle"
      ></amp-share-pane>
    </div>

  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import get from 'lodash/get'
  import find from 'lodash/find'
  import isEmpty from 'lodash/isEmpty'
  import { numberToRem } from 'mixins/utilities'
  import SingleQuoteSvg from 'static/svg/icon_single_quote_blue.svg'

  export default {
    name: 'amp-blockquote',
    props: {
      item: {
        type: Object,
        default: {},
      },
    },
    components: {
      AmpSharePane: () => import('components/article/amp/AmpSharePane'),
      SingleQuoteSvg,
    },
    computed: {
      ...mapState([
        'activeNID',
      ]),
      node() {
        return this.$store.getters.node(this.activeNID)
      },
      itemQuotes() {
        return get(this, 'item.content.quotes', [])
      },
      relatedElement() {
        const relatedElementRef = get(this, 'item.content.relatedElementRef', '')
        return get(this, `$parent.$refs[${relatedElementRef}][0]`, {})
      },
      style() {
        const style = {
          top: this.styleTop === 'auto' ? 'auto' : numberToRem(get(this, 'styleTop', 0)),
        }
        return style
      },
      shareUrl() {
        return this.node ? `${this.requestDomain()}${get(this.node, 'relative_url', '')}` : ''
      },
      shareTitle() {
        const quote = get(find(this.itemQuotes, { quoteType: 'default' }), 'value', false)
        const author = get(find(this.itemQuotes, { quoteType: 'author' }), 'value', false)

        if (quote && author) return `"${quote}", ${author}`

        return ''
      },
      shareThumbnail() {
        return get(this, 'node.images[0].style_700x400', '')
      },
    },
    methods: {
      ...mapGetters(['requestDomain']),
      repositionQuoteToRelatedEl() {
        if (!isEmpty(this.relatedElement) && this.isBodyLeftQuoteMode) {
          this.styleTop = get(this, 'relatedElement.$el.offsetTop', 'auto')
        }
        return false
      },
      quoteClassName(quoteType) {
        switch (quoteType) {
          case 'default':
            return 'blockquote-quote'
          case 'author':
            return 'blockquote-author'
          default: {
            return 'blockquote-quote'
          }
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import 'assets/scss/animate';

  .quote {
    position: relative;
    background-color: $white;
  }
  .quote-container {
    font-family: $barlow;
    margin-left: rem-calc(27);
    margin-right: rem-calc(27);
    padding-bottom: rem-calc(15);
    border-image: linear-gradient(to right, $rose, $waterspout);
    border-image-slice: 1;
    border-style: solid;
    border-width: 0 0 rem-calc(3) 0;
  }
  .blockquote-quote {
    font-size: rem-calc(26);
    line-height: rem-calc(33);
    font-style: italic;
    border-image: linear-gradient(to right, $rose, $waterspout);
    border-image-slice: 1;
    border-style: solid;
    border-width: rem-calc(3) 0 0 0;
    margin-top: rem-calc(45);
    padding-top: rem-calc(20);
    padding-left: rem-calc(10);
    padding-right: rem-calc(10);
    color: $rose;
    font-family: $barlow;
    font-weight: bold;

    .quotes {
      position: absolute;
      top: rem-calc(-33);
      left: rem-calc(10);
      width: rem-calc(80);
      height: rem-calc(44);

      &__icon {
        display: inline-block;
        position: relative;
        width: rem-calc(35);
        margin-right: rem-calc(3);

        &:first-child {
          svg {
            fill: #76FFFF;
            animation: quoteFlickering 1s step-start infinite alternate;
          }
        }

        &:last-child {
          svg {
            fill: #18FFFF;
            animation: quoteFlickeringReverse 1s step-start infinite alternate;
          }
        }
      }
    }
  }

  .blockquote-author {
    @include respond-to('desktop') {
      font-size: rem-calc(14);
      line-height: rem-calc(21);
      font-weight: initial;
    }
    @include respond-to('mobile') {
      font-size: rem-calc(14);
      line-height: rem-calc(16);
      padding-top: rem-calc(12);
    }
    color: $dark-turquoise2;
    padding: rem-calc(0 10 0 10);
    text-transform: uppercase;
    z-index: 2;

    .quotes {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// AmpBlockquote.vue?c40a837a